import React, { useEffect } from 'react';
import Slider from "react-slick";
import { initFacebookPixel } from '../facebookPixel';
import './Glimpse.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Glimpse = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="glimpse-container">
      <h1 className="faq-header">GLIMPSE</h1>
      <div className="glimpse-slider">
        <div className="glimpse-item">
          <img 
            src="https://machaxidev.blob.core.windows.net/frontend-machaxi/bImage.png" 
            alt="Glimpse image" 
          />
        </div>
      </div>
    </div>
  );
};

export default Glimpse;